import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useSetAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import { currentUserAtom } from "../atoms/authAtom";
import { authApi } from "../service/authApi";
import { ApiError } from "../service/apiClient";
import styles from "./LoginPage.module.scss";
export function LoginPage() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const setCurrentUser = useSetAtom(currentUserAtom);
    const navigate = useNavigate();
    async function handleSubmit(event) {
        event.preventDefault();
        setSubmitting(true);
        setError(null);
        try {
            const user = await authApi.login(email, password);
            setCurrentUser(user);
            navigate("/");
        }
        catch (err) {
            setError(err instanceof ApiError ? err.message : "Kunde inte logga in.");
        }
        finally {
            setSubmitting(false);
        }
    }
    return (_jsx("div", { className: styles.page, children: _jsxs("form", { className: styles.card, onSubmit: handleSubmit, children: [_jsx("h1", { children: "Sentinel" }), _jsx("p", { className: styles.subtitle, children: "Logga in f\u00F6r att se \u00F6vervakningsdashboarden." }), _jsxs("label", { children: ["E-post", _jsx("input", { type: "email", value: email, onChange: (e) => setEmail(e.target.value), required: true, autoFocus: true })] }), _jsxs("label", { children: ["L\u00F6senord", _jsx("input", { type: "password", value: password, onChange: (e) => setPassword(e.target.value), required: true })] }), error && _jsx("p", { className: styles.error, children: error }), _jsx("button", { type: "submit", disabled: submitting, children: submitting ? "Loggar in…" : "Logga in" })] }) }));
}
